<template>
    <div class="rush-24hour-banner">
        <div class="rush-24hour-banner__date">
            <span class="label">Estimated Ship Date<span class="asterisk">*</span>:</span>
            <span class="value">{{ shipDate }}</span>
        </div>
        <div class="rush-24hour-banner__note">
            Pricing includes 24Hour T-shirts Rush Service
        </div>
    </div>
</template>

<script>
export default {
    name: "Rush24HourHeader",
    props: {
        shipDate: {
            type: String,
            required: true
        }
    }
};
</script>

<style scoped>
.rush-24hour-banner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 8px 16px;
    background: #F7D642;
    border: 1px solid #F7D642;
    padding: 13px 16px;
    margin-bottom: 16px;
    margin-top: 32px;
}
.rush-24hour-banner__date .label {
    font-weight: 600;
    margin-right: 8px;
    color: #414141;
    font-size: 14px;
    line-height: 14px;
    font-family: 'mulish';
}
.rush-24hour-banner__date .asterisk {
    color: #D80606;
}
.rush-24hour-banner__date .value {
   font-weight: 600;
    margin-right: 8px;
    color: #121212;
    font-size: 16px;
    line-height: 16px;
    font-family: 'mulish';
}
.rush-24hour-banner__note {
    color: #D80606;
    font-size: 12px;
    line-height: 12px;
    font-weight: 500;
    font-family: 'mulish';
}
</style>
